import { AuthUser, OrgSettings } from '@app/account/account-api.model';
import {
  PathwayDetailsModelWithSelection,
  PathwaySummaryModel,
} from '@app/pathways/pathway-api.model';

export const isSkillsClient = (
  authUser: AuthUser,
  settings?: OrgSettings
): boolean => {
  const isSkillsClient =
    settings?.skillInventoryClient ||
    settings?.skillAnalyticsClient ||
    authUser.isSkillAnalyticsClient ||
    authUser.isSkillInventoryClient;

  return isSkillsClient;
};

export const canViewPathwayInsights = (
  authUser: AuthUser,
  pathway: PathwayDetailsModelWithSelection | PathwaySummaryModel
): boolean => {
  const { addOrganizationPathways, updateOrganizationPathways, viewReports } =
    authUser.defaultOrgInfo?.permissions;

  const isCollaborator = (pathway as PathwayDetailsModelWithSelection).authors
    ? (pathway as PathwayDetailsModelWithSelection).authors?.some(
        (author) =>
          author.userProfileKey === authUser.viewerProfile.userProfileKey
      )
    : (pathway as PathwaySummaryModel).authorProfileKeys?.includes(
        authUser.viewerProfile.userProfileKey
      );
  return (
    isCollaborator ||
    addOrganizationPathways ||
    updateOrganizationPathways ||
    viewReports
  );
};
